export default "__VITE_ASSET__BA2Dz9q1__"